import React, { Fragment, useState } from 'react'

import { faCopy, faEdit, faEllipsisV, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Menu, MenuItem, SvgIcon } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import { ContentItem } from 'routes/content-management/ContentManagement/ContentManagementProvider/Context'

const targetOrigin = { vertical: 'top', horizontal: 'right' } as const

const Icon = styled(FontAwesomeIcon)({
  marginRight: 6,
})

type ContentActionsProps = {
  data: ContentItem
  onCopy?: (data: ContentItem) => void
  onEdit?: (data: ContentItem) => void
  onDelete?: (data: ContentItem) => void
}

const ContentActions = ({ data, onCopy, onEdit, onDelete }: ContentActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const id = `${data.id}-action-menu`

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleEdit = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    if (onEdit) {
      onEdit(data)
    }
    handleClose()
  }

  const handleCopy = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    if (onCopy) {
      onCopy(data)
    }
    handleClose()
  }

  const handleDelete = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    if (onDelete) {
      onDelete(data)
    }
    handleClose()
  }

  return (
    <Fragment>
      <IconButton
        aria-label="open actions menu"
        aria-controls={id}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <SvgIcon fontSize="small">
          <FontAwesomeIcon icon={faEllipsisV} />
        </SvgIcon>
      </IconButton>
      <Menu
        id={id}
        variant="menu"
        anchorEl={anchorEl}
        anchorOrigin={targetOrigin}
        transformOrigin={targetOrigin}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleEdit}>
          <Icon icon={faEdit} />
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <Icon icon={faTrash} />
          Delete
        </MenuItem>
        <MenuItem onClick={handleCopy}>
          <Icon icon={faCopy} />
          Copy
        </MenuItem>
      </Menu>
    </Fragment>
  )
}

export default ContentActions
